import { Box } from "@chakra-ui/react";
import Sidebar from "../components/Sidebar";
import DrawerComponent from "../components/reports/subscriptions/misc/Drawer";

const Layout = (props) => {
  return (
    <Box>
      <Sidebar />
      <DrawerComponent />
      <Box p="15px" overflowY="auto" minH="400px" ml="260px">
        {props.children}
      </Box>
    </Box>
  );
};

export default Layout;
